import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import SPCheck1 from "../images/sp_checkout_1.jpg"
import SPCheck2 from "../images/sp_checkout_2.jpg"
import SPCheck3a from "../images/sp_checkout_3_1.jpg"
import SPCheck3b from "../images/sp_checkout_3_2.jpg"
import SPCheck4 from "../images/sp_checkout_4.jpg"
import SPCheck5 from "../images/sp_checkout_5.jpg"

const SpCheckout = () => (
  <Layout>
    <SEO title="Samritan's Purse Checkout" />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader
        title="Samaritan's Purse Checkout"
        subtitle="Front-end | Design"
      />
      <ProductSection image={SPCheck1} />
      <ProductSection image={SPCheck2} />
    </div>
  </Layout>
)

export default SpCheckout
